export default "__VITE_PUBLIC_ASSET__cdb0a885__"